export const GAME_PERCENT_FEE_COEF = 0.03

export const GAME_PERCENT_FEE_SERVICE_IDS = [
  'mobile-legends-bang-bang',
  'honkai-star-rail',
  'zenless-zone-zero',
  'genshin',
  'blood-strike',
  'wuthering-waves',
  'top-eleven-football-manager-donate',
  'marvel-rivals',
  'love-and-deepspace',
]
